import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { MyButton } from '@/components/uiComponents';
import { adminProvider } from '@/providers';
import { appSetNotification } from '@/store';
import { NotificationTypeEnum } from '@/types';

import { downloadAdminUsersCsv } from '../adminUsersCsv';

const EXPORT_ERROR_MESSAGE = 'Error when exporting users';

export const ExportUsersCsvButton = (): JSX.Element => {
  const dispatch = useDispatch();
  const exportInProgressRef = useRef(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    if (exportInProgressRef.current) {
      return;
    }

    exportInProgressRef.current = true;
    setIsExporting(true);

    try {
      const { ok, data, message, status } = await adminProvider.exportUsers();

      if (!ok || data === null) {
        dispatch(
          appSetNotification(NotificationTypeEnum.Error, message || EXPORT_ERROR_MESSAGE, status)
        );
        return;
      }

      downloadAdminUsersCsv(data);
    } catch {
      dispatch(appSetNotification(NotificationTypeEnum.Error, EXPORT_ERROR_MESSAGE));
    } finally {
      exportInProgressRef.current = false;
      setIsExporting(false);
    }
  };

  return (
    <MyButton
      data={{
        buttonName: isExporting ? 'Exporting...' : 'Export CSV',
        styleType: 'cancel',
        variant: 'contained',
        customWidth: '130px',
      }}
      disabled={isExporting}
      onClick={handleExport}
    />
  );
};
